import { Pipe, PipeTransform } from '@angular/core';
import { TimeInterval } from '@eceos/domain';

@Pipe({
  name: 'interestArrears'
})
export class InterestArrearsPipe implements PipeTransform {

  transform(type: { name, interval: TimeInterval }): string {
    switch (type.name) {
      case 'fixed':
        return 'Valor fixo' + this.transformInterval(type.interval);
      case 'compound':
        return 'Compostos' + this.transformInterval(type.interval);
      case 'simple':
        return 'Simples' + this.transformInterval(type.interval);
    }
  }

  private transformInterval(interval: TimeInterval): string {
    return interval === TimeInterval.PER_DAY ? ' (Por dia)' : ' (Por mês)';
  }
}
